import createAxiosInstance from '../createAxiosInstance'
import Vue from 'vue'

// TODO: 請後端協助讓 "Content-Type" 可以吃 "multipart/form-data"，再拔除 urlEncodeFormData
function urlEncodeFormData (fd) {
  const params = new URLSearchParams(fd)
  return params.toString()
}
const mvcPath = process.env.NODE_ENV === 'development' ? '/localmvc' : process.env.VUE_APP_MVC_URL
const mvcInstance = createAxiosInstance(mvcPath)

const mapiPath = process.env.VUE_APP_MAPI_URL
const mapiInstance = createAxiosInstance(mapiPath)

const corePath = process.env.VUE_APP_CORE_URL
const coreInstance = createAxiosInstance(corePath)

export const apiOrderFood = {
  exportOrderRecord: ({
    startDate,
    endDate,
    household,
    pointType,
    status,
    user
  }, config) => {
    const params = {
      StartDate: startDate,
      EndDate: endDate,
      TabletId: household,
      CashStatus: pointType,
      VoidStatus: status,
      StoreUser: user
    }
    return mapiInstance.get('/PointOrderFood/export', { params, ...config })
  },
  getFoodItemList: () => mvcInstance.get('/TabletPoint/GetMenuPointList?isCheck=0'),
  getOrderDetail: (id) => coreInstance.get(`/api/Community/OrderingReceipt/${id}`),
  getOrderFoodRecords: ({
    startDate,
    endDate,
    household,
    pointType,
    status,
    user,
    offset,
    maxCount
  }) => {
    const params = {
      StartDate: startDate,
      EndDate: endDate,
      TabletId: household,
      CashStatus: pointType,
      VoidStatus: status,
      StoreUser: user,
      Offset: offset,
      MaxCount: maxCount
    }
    return mapiInstance.get('/PointOrderFood', { params })
  },
  // 儲值1 回補2 作廢3 這裡只用得到作廢
  getVoidNoteTemplates: () => mapiInstance.get('/ServicePointNoteTemplate?TypeId=3'),
  // 取得拒單範本
  getRejectNoteTemplates: () => mapiInstance.get('/ServicePointNoteTemplate?TypeId=4'),
  getPointTypeList: () => mvcInstance.get('/TabletPoint/GetPointTypeList'),
  getPointByHousehold: (householdId) => mvcInstance.get(`/TabletPoint/GetTabletPoint?tablet=${householdId}`),
  getSystemUserList: () => mapiInstance.get('/Community/FeatureStaffs?FeatureId=8'), // 8為點餐的權限Id
  // TODO: 請後端協助讓 "Content-Type" 可以吃 "multipart/form-data"，再改回統一使用 Axios
  // 1. 後端吃的資料格式為 formData
  // 2. 後端格式設定不吃 "Content-Type": "multipart/form-data" 只吃 "application/x-www-form-urlencoded; charset=UTF-8"，否則報錯
  // 3. axios 若資料為 formData 則無法重寫 "Content-Type"，必定將設置為 "multipart/form-data"
  // 4. 後端未動的情形下前端先用 fetch 取代 axios 來達成此效果
  // 5. 前端希望可以統一使用 axios 來打 API，故需請後端協助
  // operateTabletPoint: (data) => instance.request(
  //   {
  //     url: `/TabletPoint/OperateTabletPoint`,
  //     method: 'post',
  //     data,
  //     // 無效配置
  //     headers: {
  //       // "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
  //     },
  //   },
  // )
  // 現行替代方案
  operateTabletPoint: (data) => fetch(`${mvcPath}/TabletPoint/OperateTabletPoint`, {
    method: 'post',
    body: urlEncodeFormData(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-Correlation-Id': Vue.prototype.$getGuid()
    }
  }).then(async (res) => {
    return {
      data: await res.json()
    }
  }).catch((err) => {
    console.log(err)
  }),
  voidOrder: ({ id, note }) => mvcInstance.put('/TabletPoint/OperateTabletPointVoid', { Id: id, Note: note })
}
